// extracted by mini-css-extract-plugin
export default {"container":"Settings_container_jAFwM","list":"Settings_list_OjapK","item":"Settings_item_oKun7","label":"Settings_label_BGnrK"};